import {gql} from 'apollo-boost';

export const GET_CLASSROOMS = gql`
  query getClassRooms{
    getClassRooms {
      id
      #      classRoomOwned {
      #        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
      #        classRoomType{
      #          id nameLocal nameEng capacity label
      #        }
      #      }
      courseOutlineRegistration{
        id
        #        degree{
        #          id code nameLocal nameEng
        #        }
        #        subjectGroup{
        #          id code nameLocal nameEng
        #        }
        courseOutline {
          id
        }
      }
      classSection{
        id descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentQty studentRegisterQty
      }
      #      sectionNo
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      #      teacherCode
      subject{
        id code nameLocal nameEng
      }
      #      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
    }
  }
`;

export const GET_AVAILABLE_CLASSROOMS = gql`
  query getAvailableClassRooms{
    getAvailableClassRooms {
      id
      sectionNo
      teacherCode
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
    }
  }
`;

export const GET_LEARNING_CLASSROOMS = gql`
  query getLearningClassRooms{
    getLearningClassRooms {
      id
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      courseOutlineRegistration{
        id
        courseOutline {
          id
        }
      }
      degree{ id code }
      subjectGroup{ id code}
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate
        learnSpanNo examSpanNo studentQty studentRegisterQty
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        telephone email availableTime socialMedia isSpecialTeacher
      }
      subject{
        id code nameLocal nameEng
      }
    }
  }
`;

export const GET_LEARNING_CLASSROOMS_DDL = gql`
  query getLearningClassRoomsDdl($name: String!, $limit: Int){
    getLearningClassRoomsDdl(
      name: $name
      limit: $limit
    ) {
      id
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      courseOutlineRegistration{
        id periodCode
        academicPeriod { id year semester}
        courseOutline {
          id
        }
      }
      degree{ id code }
      subjectGroup{ id code}
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate
        learnSpanNo examSpanNo studentQty studentRegisterQty
      }
      teacher{
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        telephone email availableTime socialMedia isSpecialTeacher
      }
      subject{
        id code nameLocal nameEng
      }
    }
  }
`;

export const GET_CLASSROOMS_BY_FILTER = gql`

  query getClassRoomsByFilter($classRoomFilterInput: ClassRoomFilterInput){
    getClassRoomsByFilter (
      classRoomFilterInput: $classRoomFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input ClassRoomFilterInput {
      #      degreeId: ID
      #      subjectGroupId: ID
      #      classRoomOwnedId: ID
      #      courseOutlineRegistrationId: ID
      #      classSectionId: ID
      #      sectionNo: Int
      #      teacherId: ID
      #      teacherCode: String
      #      subjectId: ID
      #      subjectCode: String
      #      nameLocal: String
      #      nameEng: String
      #      capacity: Int
      #      startDate: String
      #      endDate: String
      #      isAvailable: Boolean
      #      isActive: Boolean
      #      classRoomTypeId: ID
      #  }
    ){
      id
      #      classRoomOwned {
      #        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
      #        classRoomType{
      #          id nameLocal nameEng capacity label
      #        }
      #      }
      teacher{
        #        prefix{
        #          id nameLocal nameEng nameShortLocal nameShortEng
        #        }
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
      teacherCode
      #      subject{
      #        id code nameLocal nameEng
      #      }
      #      degree{
      #        id code nameLocal nameEng
      #      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive

    }
  }
`;

export const GET_CLASSROOM = gql`
  query getClassRoom($id : ID!){
    getClassRoom (
      id: $id
    )
    {
      id
      degree{ id code nameLocal nameEng}
      subjectGroup{ id code nameLocal nameEng}
      classRoomOwned {
        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
        classRoomType{
          id nameLocal nameEng capacity label
        }
      }
      courseOutlineRegistration{
        id
        degree{
          id
        }
        subjectGroup{
          id
        }
        courseOutline {
          id
          courseOutlineUnits{
            id
          }
          vdoSets{
            id code description totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
        }
        classSections{
          id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
          classRoom{ id}
        }
      }
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
      sectionNo
      teacher{
        id
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        code firstNameLocal lastNameLocal firstNameEng lastNameEng
        telephone email socialMedia availableTime isSpecialTeacher picturePath
      }
      teacherCode
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
    }
  }
`;

export const GET_CLASSROOMS_BY_STUDENT_NOT_REGISTER = gql`
  query getClassRoomsByStudentNotRegister(
    $studentId: ID!,
    $academicPeriodId: ID!,
    $studentEnrollId: ID
  ) {
    getClassRoomsByStudentNotRegister(
      studentId: $studentId,
      academicPeriodId: $academicPeriodId,
      studentEnrollId: $studentEnrollId
    )
    {
      id sectionNo studentRegisterQty capacity
      courseOutlineRegistration{
        id
      }
      subjectCode
      teacherCode
#      subject{
#        id code nameLocal nameEng creditCalGrade
#      }
#      teacher{
#        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
#      }
      classSection{
        id sectionNo studentRegisterQty studentQty learnSpanNo examSpanNo
      }

    }
  }
`;

export const ADD_CLASSROOM = gql`
  mutation addClassRoom(
    $degreeId: ID
    $subjectGroupId: ID
    $classRoomOwnedId: ID!
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $teacherId: ID
    $subjectId: ID
    $classRoomTypeId: ID!
    $classRoomInput: ClassRoomInput!
    $classSectionForRegistrationInput: ClassSectionForRegistrationInput
    $classSectionInput: ClassSectionInput
  )
  {
    addClassRoom(
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      classRoomOwnedId: $classRoomOwnedId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      teacherId: $teacherId
      subjectId: $subjectId
      classRoomTypeId: $classRoomTypeId
      classRoomInput: $classRoomInput
      classSectionForRegistrationInput: $classSectionForRegistrationInput
      classSectionInput: $classSectionInput
    )
    {
      id
      degree{ id code nameLocal nameEng}
      subjectGroup{ id code nameLocal nameEng}
      classRoomOwned {
        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
        classRoomType{
          id nameLocal nameEng capacity label
        }
      }
      courseOutlineRegistration{
        id
        degree{
          id
        }
        subjectGroup{
          id
        }
        courseOutline {
          id
          courseOutlineUnits{
            id
          }
          vdoSets{
            id code description totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
        }
        classSections{
          id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        }
      }
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
      sectionNo
      teacher{
        id
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        code firstNameLocal lastNameLocal firstNameEng lastNameEng
        telephone email socialMedia availableTime isSpecialTeacher picturePath
      }
      teacherCode
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
    }
  }
`;

export const UPDATE_CLASSROOM = gql`
  mutation updateClassRoom(
    $id: ID!,
    $degreeId: ID
    $subjectGroupId: ID
    $classRoomOwnedId: ID!
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $teacherId: ID
    $subjectId: ID
    $classRoomTypeId: ID!
    $classRoomInput: ClassRoomInput!
    $classSectionForRegistrationInput: ClassSectionForRegistrationInput
    $classSectionInput: ClassSectionInput
  ) {
    updateClassRoom(
      id: $id
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      classRoomOwnedId: $classRoomOwnedId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      teacherId: $teacherId
      subjectId: $subjectId
      classRoomTypeId: $classRoomTypeId
      classRoomInput: $classRoomInput
      classSectionForRegistrationInput: $classSectionForRegistrationInput
      classSectionInput: $classSectionInput
    )
    {
      id
      degree{ id code nameLocal nameEng}
      subjectGroup{ id code nameLocal nameEng}
      classRoomOwned {
        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
        classRoomType{
          id nameLocal nameEng capacity label
        }
      }
      courseOutlineRegistration{
        id
        degree{
          id
        }
        subjectGroup{
          id
        }
        courseOutline {
          id
          courseOutlineUnits{
            id
          }
          vdoSets{
            id code description totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
        }
        classSections{
          id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        }
      }
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
      sectionNo
      teacher{
        id
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        code firstNameLocal lastNameLocal firstNameEng lastNameEng
        telephone email socialMedia availableTime isSpecialTeacher picturePath
      }
      teacherCode
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
    }
  }
`;

export const DELETE_CLASSROOM = gql`
  mutation deleteClassRoom($id: ID!) {
    deleteClassRoom(
      id: $id
    )
    {
      id
      degree{ id code nameLocal nameEng}
      subjectGroup{ id code nameLocal nameEng}
      classRoomOwned {
        id inUseClassRoomQty availableClassRoomQty maxClassRoomQty capacity startDate endDate
        classRoomType{
          id nameLocal nameEng capacity label
        }
      }
      courseOutlineRegistration{
        id
        degree{
          id
        }
        subjectGroup{
          id
        }
        courseOutline {
          id
          courseOutlineUnits{
            id
          }
          vdoSets{
            id code description totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
        }
        classSections{
          id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        }
      }
      classSection{
        id sectionNo descriptionLocal descriptionEng startClassDate learnSpanNo examSpanNo studentRegisterQty
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
      }
      sectionNo
      teacher{
        id
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        code firstNameLocal lastNameLocal firstNameEng lastNameEng
        telephone email socialMedia availableTime isSpecialTeacher picturePath
      }
      teacherCode
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      nameLocal
      nameEng
      studentRegisterQty
      capacity
      startDate
      endDate
      isAvailable
      isActive
    }
  }
`;

